<template>
  <div>
    <navigation-label
      :label="($attrs.label ? $attrs.label : displayAsSingular)"
      :displayAsSingular="displayAsSingular"
      :displayAsPlural="displayAsPlural"
      :tooltip="`${displayAsSingular} Maintenance`"
      routeTo="../customers"
    />

    <v-container
      class="pa-0 ma-0"
    >
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          sm="12"
          md="11"
        >
          <v-combobox
            :id="`key-customer-${$attrs.id}`"
            v-model="internalValue"
            :items="customers.data"
            item-text="description"
            item-value="id"
            autofocus
            outlined
            dense
            clearable
            class="ml-1 mt-0 mb-0"
            :hint="`Select a ${displayAsSingular} ${$attrs.appendhint}`"
            :loading="customers.isBusy"
            :rules="[appRules.validOption(internalValue, customers.data, `${displayAsSingular} does not exist in the list.`)]"
            @change="onChange"
          />
        </v-col>

        <v-col
          cols="12"
          sm="1"
          :class="colClass"
        >
          <v-tooltip
            v-if="!$attrs.disableIconNav"
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-small
                color="primary"
                v-bind="attrs"
                :disabled="disablePrevious"
                v-on="on"
                @click="previous_onClick"
              >
                <v-icon>mdi-skip-previous-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Previous {{ displayAsSingular }}</span>
          </v-tooltip>

          <v-tooltip
            v-if="!$attrs.disableIconNav"
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                x-small
                color="primary"
                v-bind="attrs"
                :disabled="disableNext"
                v-on="on"
                @click="next_onClick"
              >
                <v-icon>mdi-skip-next-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Next {{ displayAsSingular }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'
  import NavigationLabel from '@/components/maintenance/controls/NavigationLabel'

  export default {
    name: 'SelectCustomer',

    components: {
      NavigationLabel,
    },

    props: {
      value: {
        type: Object,
        default: null,
      },
      enableAll: {
        type: Boolean,
        default: false,
        required: false,
      },
    },

    data () {
      return {
        internalValue: this.value,
      }
    },

    computed: {
      appRules: get('app/rules'),
      customers: get('customer/customers'),
      displayAsSingular: get('customer/displayAsSingular'),
      displayAsPlural: get('customer/displayAsPlural'),
      colClass () {
        let newClass = 'text-no-wrap d-inline'
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            newClass = 'd-none'
            break
        }
        return newClass
      },
      disablePrevious () {
        let disabledButton = true

        if (disabledButton && this.customers.data) {
          if (this.customers.data.length > 0) {
            disabledButton = this.customers.isFirst
          }
        }

        return disabledButton
      },
      disableNext () {
        let disabledButton = true

        if (disabledButton && this.customers.data) {
          if (this.customers.data.length > 0) {
            disabledButton = this.customers.isLast
          }
        }

        return disabledButton
      },
    },

    watch: {
      internalValue: {
        handler (val, oldVal) {
          if (val && {}.hasOwnProperty.call(val, 'id')) {
            if (oldVal &&
              val.id === oldVal.id &&
              val.description === oldVal.description) return

            this.$emit('input', this.internalValue)
          }
        },
      },
      value: {
        handler (val, oldVal) {
          if (val && {}.hasOwnProperty.call(val, 'id')) {
            if (oldVal &&
              val.id === oldVal.id &&
              val.description === oldVal.description) return

            this.internalValue = val
          }
        },
      },
    },

    created () {
      this.initialize()

      this.unsubscribe = this.$store.subscribe((mutation) => {
        switch (mutation.type) {
          case 'customer/previous':
          case 'customer/next':
            this.$emit('change', mutation.payload)
            break
        }
      })
    },

    beforeDestroy () {
      this.unsubscribe()
    },

    methods: {
      initialize () {
        if (this.enableAll && this.customers.data.length > 1) {
          this.$store.dispatch('customer/addAllOption')
        } else {
          this.$store.dispatch('customer/removeAllOption')
        }
      },

      onChange (selectedItem) {
        // This dispatch probably belongs in the parent's @change, but easier to handle setFrom here
        if (this.$attrs.useFrom) {
          this.$store.dispatch('customer/setFrom', selectedItem)
        } else {
          this.$store.dispatch('customer/setSelected', selectedItem)
        }

        this.$emit('change', selectedItem)
      },

      previous_onClick () {
        this.$store.dispatch('customer/previous')
      },

      next_onClick () {
        this.$store.dispatch('customer/next')
      },
    },
  }
</script>

<style scoped>

</style>
